$(document).ready(function () {
  $('.generalmessage').prependTo('header');

  $(window).load(function () {
    const sponsorsTitle = $('.homepageh1').text();
    $('.homepageh1').replaceWith(`<h2 class="homepageh1">${sponsorsTitle}</h2>`);
  });

  $('header .viewcart').clone().prependTo('header .mobile-wrapper');

  $('header .headerInnerContent').append('<div class="abstract-bg"></div>');

  $('header .mobile-nav-toggle').append('<div></div><div></div><div></div>');
});
